module.exports = __webpack_public_path__ + "img/logo.d29d79c2.png";